import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

export interface ContactData {
  contactName: string;
  email: string;
  address: string;
  invoiceEmail: string;
  notificationsEmail: string;
}

@Component({
  selector: 'app-charity-details',
  templateUrl: './charity-details.component.html',
  styleUrls: ['./charity-details.component.css'],
  standalone: false
})
export class CharityDetailsComponent implements OnInit {
  activeTab: string = 'organization';
  isEditMode: boolean = false; // true for Select, false for Add New
  
  // Organization data
  organizationName: string = '';
  orgId: string = '';
  ccn: string = '';
  address: string = '';
  client: boolean = false;
  charitableActivity: string = '';
  parentOrg: string = '';
  childOrgs: string = '';
  alternativeNames: string = '';
  
  // Services data
  safTier: string = '';
  services = [
    { service: 'Discretionary', invoicing: 'Monthly', subscribed: true },
    { service: 'Named', invoicing: 'Monthly', subscribed: true },
    { service: 'Trust', invoicing: 'Monthly', subscribed: true },
    { service: 'Legacy Link', invoicing: '', subscribed: false }
  ];
  
  // Contacts data
  contacts: ContactData[] = [
    { contactName: 'Accounts Team', email: 'accounts@charity.co.uk', address: '1 Test Street; Test Town; TE1 1TE', invoiceEmail: 'Y', notificationsEmail: 'N' },
    { contactName: 'Legacy Admin', email: 'ladmin@charity.co.uk', address: '2 Test Street; Test Town; TE1 1TE', invoiceEmail: 'N', notificationsEmail: 'Y' },
    { contactName: 'John Smith', email: 'jsmith@charity.co.uk', address: '3 Test Street; Test Town; TE1 1TE', invoiceEmail: 'N', notificationsEmail: 'Y' }
  ];

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.isEditMode = params['mode'] === 'edit';
      
      if (this.isEditMode && params['charity']) {
        // Fill with selected charity data
        const charityData = JSON.parse(params['charity']);
        this.loadCharityData(charityData);
      }
    });
  }

  loadCharityData(charity: any) {
    this.organizationName = charity.charityName;
    this.orgId = charity.orgId;
    this.ccn = charity.ccn;
    this.address = charity.address;
    this.client = charity.client === 'Y';
    // Set other default values for demo
    this.charitableActivity = 'ComboBox';
    this.parentOrg = 'ComboBox';
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  onSave() {
    // Add save logic here
  }

  onSuspend() {
    // Add suspend logic here
  }

  onDeleteAccount() {
    // Add delete logic here
  }

  onAddNewContact() {
    // Add new contact logic here
  }

  goBack() {
    this.router.navigate(['/charity-database']);
  }
}
